import { useEffect, useState } from "react"
import { listStudentSubjects } from "../../../api/studentSubjects"
import type { StudentSubject } from "../Questions/types"

/** Shared loader for learner subjects (dashboard, papers, filters). */
const useStudentSubjects = () => {
  const [subjects, setSubjects] = useState<StudentSubject[]>([])
  const [subjectsLoading, setSubjectsLoading] = useState(true)
  const [subjectsError, setSubjectsError] = useState("")

  useEffect(() => {
    let cancelled = false
    setSubjectsLoading(true)
    setSubjectsError("")
    listStudentSubjects()
      .then((res) => {
        if (cancelled) return
        if (res.data?.success && Array.isArray(res.data.data)) {
          setSubjects(res.data.data)
        } else {
          setSubjects([])
          setSubjectsError(res.data?.message || "Could not load subjects")
        }
      })
      .catch(() => {
        if (cancelled) return
        setSubjects([])
        setSubjectsError("Could not load subjects")
      })
      .finally(() => {
        if (!cancelled) setSubjectsLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return {
    subjects,
    subjectsLoading,
    subjectsError,
  }
}

export default useStudentSubjects
